import { Text } from "@kvix/ui";
import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  Container,
  makeStyles,
  Modal,
  Paper,
} from "@material-ui/core";
import { motion } from "framer-motion";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { KvixUserContext } from "../../contexts/user";

const useStyles = makeStyles((theme) => ({
  modal: {
    margin: 0,
    top: "unset !important",
  },
  container: {
    width: "100%",
    display: "flex",
    height: "100%",

    paddingBottom: theme.spacing(0.5),

    boxShadow: "0 0 50px -20px rgba(0, 0, 0, 0.75)",
  },
  animatedContainer: {
    ["position" as any]: "fixed",
    ["bottom" as any]: -200,
    ["left" as any]: 0,
    ["right" as any]: 0,
  },
  checkboxContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  doneButton: {
    color: theme.palette.type === "dark" ? "#425784" : "#FEE9EE",
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    backgroundColor:
      theme.palette.type !== "dark"
        ? theme.palette.primary.main
        : "rgb(31, 40, 51)",
    "&:hover": {
      backgroundColor:
        theme.palette.type !== "dark"
          ? theme.palette.primary.dark
          : "rgb(31, 40, 51)",
    },
  },
}));

const AdvertismentComponent: React.FC<{
  open?: boolean;
  onClose?: () => void;
}> = (props) => {
  const classes = useStyles(props);
  const { user, actions } = useContext(KvixUserContext);
  const { t, ready } = useTranslation("acceptAdvertisment");
  const [acceptAdvertisment, setAcceptAdvertisment] = useState(
    user.acceptAdvertisment || false
  );
  const [expanded, setExpanded] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(props.open);
    setExpanded(props.open);
  }, [props.open]);

  const Done = async () => {
    if (user.acceptAdvertisment === acceptAdvertisment) {
      setVisible(false);
      setExpanded(false);
    } else {
      await actions.updateAdvertisment(acceptAdvertisment);
    }

    props.onClose();
  };

  const animateOptions = {
    expanded: {
      height: 300,
      maxWidth: 838,
      width: "95%",
      ["margin" as any]: "auto",
      ["bottom" as any]: 0,
      ["top" as any]: 0,
      ["left" as any]: 0,
      ["right" as any]: 0,
    },
    default: {
      ["bottom" as any]: 0,
    },
  };

  if (!ready) {
    return null;
  }

  return (
    <Modal
      open={visible}
      disableScrollLock
      closeAfterTransition
      BackdropComponent={Backdrop}
      className={classes.modal}
    >
      <motion.div
        className={classes.animatedContainer}
        animate={expanded ? animateOptions.expanded : animateOptions.default}
        transition={{ duration: 0.3 }}
      >
        <Paper
          className={classes.container}
          style={{ paddingTop: expanded ? 40 : 8 }}
        >
          <Container maxWidth="lg" className={classes.wrapper}>
            <Box className={classes.checkboxContainer}>
              <Checkbox
                checked={acceptAdvertisment}
                onChange={() => setAcceptAdvertisment(!acceptAdvertisment)}
              />
              <Text>{t("checkboxText")}</Text>
            </Box>
            <Box className={classes.doneButton}>
              <Button
                className={classes.button}
                variant="contained"
                onClick={Done}
              >
                {t("done")}
              </Button>
            </Box>
          </Container>
        </Paper>
      </motion.div>
    </Modal>
  );
};

export const Advertisment: React.FC<{
  open?: boolean;
  onClose?: () => void;
}> = (props) => {
  return <AdvertismentComponent {...props} />;
};
